<div
  *renderingPermissionDirective="[
    'BulkSettingRequester',
    'BulkSettingReviewer',
  ]"
  class="request-creation-modal">
  <div class="request-creation-modal__header">
    <span class="request-creation-modal__header__label">
      New Settings Modification Request
    </span>
    <button
      class="btn-close float-end"
      type="button"
      (click)="close()"></button>
  </div>

  <div
    *ngIf="!predefinedEntity"
    class="request-creation-modal__toggle">
    <span
      class="request-creation-modal__toggle__option lx-label"
      [ngClass]="{ selected: !showBulk }"
      (click)="setShowBulk(false)">
      Set Single
    </span>
    <span
      class="request-creation-modal__toggle__option lx-label"
      id="bulk-tab"
      [ngClass]="{ selected: showBulk }"
      (click)="setShowBulk(true)">
      Set Multiple
    </span>
  </div>

  <div *ngIf="!showBulk">
    <div
      *ngIf="!predefinedEntity"
      class="request-creation-modal__entities">
      <div class="lx-label">
        Set By
        <span class="request-creation-modal__required">*</span>
      </div>

      <label
        class="request-creation-modal__radio"
        for="companyGroup">
        <input
          checked="checked"
          id="companyGroup"
          name="companyGroup"
          type="radio"
          value="Group"
          [(ngModel)]="selectedEntityType" />
        Company/Group
      </label>

      <label
        class="request-creation-modal__radio"
        for="device">
        <input
          id="device"
          name="device"
          type="radio"
          value="Device"
          [(ngModel)]="selectedEntityType" />
        Device
      </label>

      <label
        class="request-creation-modal__radio"
        for="vehicle">
        <input
          id="vehicle"
          name="vehicle"
          type="radio"
          value="Vehicle"
          [(ngModel)]="selectedEntityType" />
        Vehicle
      </label>
      <div class="lx-label">
        Select Company
        <span class="request-creation-modal__required">*</span>
      </div>
      <company-selector
        class="request-creation-modal__company_selector"
        (companySelect)="onCompanySelect($event)"></company-selector>

      <div class="lx-label">
        Select Entity
        <span class="request-creation-modal__required">*</span>
      </div>
      <dcc-entity-search
        #entitySearch
        id="entity-search"
        [clearTextOnSelect]="true"
        [company]="selectedCompany"
        [disable]="!selectedCompany"
        [entityTypes]="[selectedEntityType]"
        (entity)="onEntitySelected($event)"></dcc-entity-search>
    </div>

    <dcc-entity-path-display
      [companiesEntities]="companiesEntities"
      [devicesEntities]="devicesEntities"
      [groupsEntities]="groupsEntities"
      [predefinedEntity]="predefinedEntity"
      [stackEntities]="stackEntities"
      [vehiclesEntities]="vehiclesEntities"
      (deleted)="deleteEntity($event)"></dcc-entity-path-display>
  </div>

  <div
    *ngIf="showBulk"
    class="request-creation-modal__bulk">
    <bulk-entity-input
      id="bulk-groups"
      placeholder="Group IDs"
      title="Groups"
      [entities]="groupsEntities"
      [entityType]="entityTypes.group"
      (bulkAdd)="addEntities($event)"></bulk-entity-input>
    <bulk-entity-input
      id="bulk-vehicles"
      placeholder="Vehicle IDs"
      title="Vehicles"
      [entities]="vehiclesEntities"
      [entityType]="entityTypes.vehicle"
      (bulkAdd)="addEntities($event)"></bulk-entity-input>
    <bulk-entity-input
      id="bulk-devices"
      placeholder="Serial Numbers"
      title="Devices"
      [entities]="devicesEntities"
      [entityType]="entityTypes.device"
      (bulkAdd)="addEntities($event)"></bulk-entity-input>
  </div>
  <hr class="request-creation-modal__divider" />
  <div class="request-creation-modal__description">
    <div
      class="lx-label"
      for="description">
      Description
    </div>
    <textarea
      id="description"
      placeholder="Enter reason for the setting modification"
      type="text"
      [(ngModel)]="description"></textarea>
  </div>

  <div *ngIf="predefinedSetting">
    <div class="lx-label">Setting</div>
    <div>{{ setting.name | settingName }}</div>
  </div>

  <div *ngIf="!predefinedSetting">
    <div class="lx-label">
      Select Setting
      <span class="request-creation-modal__required">*</span>
    </div>
    <setting-selector
      (settingSelected)="onSettingSelected($event)"></setting-selector>
  </div>

  <div
    *ngIf="setting"
    class="request-creation-modal__setting-selectors">
    <video-profile-selector
      *ngIf="isVideoProfile; else genericValueSelector"
      [currentValues]="videoProfileCurrentValues"
      [updatingSetting]="updatingSetting"
      (settingsAdded)="settingsAdded($event)"></video-profile-selector>
    <ng-template #genericValueSelector>
      <setting-value-selector
        [setting]="setting"
        [updatingSetting]="updatingSetting"
        (settingAdded)="settingAdded($event)"></setting-value-selector>
    </ng-template>
  </div>

  <div
    *ngIf="settings.length > 0 && !isVideoProfile"
    class="request-creation-modal__setting-table">
    <table>
      <thead>
        <tr>
          <th>Setting</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let s of settings">
          <td>{{ s.name | settingName }}</td>
          <td>{{ s.displayValue }}</td>
          <td>
            <button
              class="request-creation-modal__body__setting-table__remove lx-btn-small lx-btn-text"
              type="button"
              (click)="removeSetting(s.name)">
              <i class="lx-icon lx-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="request-creation-modal__footer">
    <button
      class="lx-btn lx-btn-secondary"
      type="button"
      (click)="close()">
      Cancel
    </button>
    <button
      class="lx-btn lx-btn-primary"
      id="submit"
      [disabled]="!canSubmit()"
      (click)="submit()">
      {{ isVideoProfile ? 'Submit Request' : 'Request' }}
    </button>
  </div>
</div>
